import { TableHeading } from "../../../../components/common/table/TableDesign";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
  // ✅ NEW: Alphanumeric with symbols
  ALPHANUMERIC_WITH_SYMBOLS: /^[a-zA-Z0-9\s!@#$%^&*()_\-+=[\]{};:'"\\|,.<>/?`~]+$/,
};

/*----------------------------*/
/* Quote Screen */


/*----------------------------*/
export const leadProfessionalChargesHeading: TableHeading[] = [
  { label: "Service" },
  { label: "Service Description", align: "left" },
  { label: "Day", align: "center" },
  { label: "Provisional Date", align: "left" },
  { label: "Price", align: "center" },
  { label: "Drivers" },
  { label: "Porters", align: "left" },
  { label: "Packers", align: "left" },
  { label: "Wages", align: "center" },
  { label: "Vehicles", align: "center" },
  { label: "", align: "center" },
  { label: "Fuel", align: "center" },
];

export const leadProfessionalChargesFields = [
  // {
  //   id: "typeName",
  //   type: "staticText",
  // },
  {
    id: "typeName",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    placeHolder: "",
    type: "text",
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC_WITH_SYMBOLS,
  },
  {
    id: "day",
    placeholder: "Day",
    type: "text",
    width: "40px",
    inputProps: {
      maxLength: 2,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "provisionalDate",
    type: "staticText",
    width: "120px",
  },
  {
    id: "price",
    placeholder: "Charge",
    type: "text",
    width: "80px",
    inputProps: {
      maxLength: 6,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "driverQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "porterQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "packerQty",
    placeholder: "Qty",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "wageCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: "price",
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vehicleTypeId",
    placeholder: "",
    type: "select",
    width: "100px",
  },
  {
    id: "vehicleQty",
    placeholder: "Qty",
    type: "text",
    width: "35px",
    inputProps: {
      maxLength: 2,
    },
    // disabled: true,
    valueFormat: "number",
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "fuelCharge",
    placeholder: "Charge",
    type: "text",
    inputProps: {
      maxLength: 50,
    },
    valueFormat: "price",
    prefixIcon: "£",
    patternAllowed: patternConstant?.PRICE,
  },
];